var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-card-container block-pulse"},[_c('div',{staticClass:"info-area"},[_c('div',{staticClass:"user-img"}),_c('div',{staticClass:"activity-indicator-area"},[_c('div',{staticClass:"activity-status block"},[_vm._v("blocktext")])])]),_c('div',{staticClass:"contact-area"},[_c('button',{staticClass:"contact-button block"},[_vm._v("blocktext")])])])
}]

export { render, staticRenderFns }